import moment from 'moment'
import { find } from 'lodash'

export default {
  computed: {
    graduateIsEnabled () {
      return this.graduate.enabled
    },

    graduateIsDisabled () {
      return !this.graduate.enabled
    },

    currentPlacement () {
      return find(this.graduate.placements, (placement) => {
        let startDate = moment(placement.start_date).startOf('day')
        let endDate = moment(placement.end_date).endOf('day')

        if (moment().isBetween(startDate, endDate)) {
          return placement
        }
      })
    },

    firstPlacement () {
      return this.graduateFindPlacement(1)
    },

    secondPlacement () {
      return this.graduateFindPlacement(2)
    },

    homeAgency () {
      let firstPlacement = find(this.graduate.placements, (placement) => {
        return placement.number === 1
      })

      if (firstPlacement) {
        return firstPlacement.agency ? firstPlacement.agency.name : 'Unassigned'
      }

      return null
    },

    currentPlacementAgency () {
      if (!this.currentPlacement) {
        return null
      }

      if (!this.currentPlacement.agency) {
        return 'Unassigned'
      }

      return this.currentPlacement.agency.name
    },

    currentPlacementManager () {
      if (!this.currentPlacement || !this.currentPlacement.manager) {
        return null
      }

      return this.currentPlacement.manager
    }
  },

  methods: {
    graduateFindPlacement (number) {
      let placement = find(this.graduate.placements, { number })

      if (placement) {
        return placement
      }

      return null
    }
  }
}
